export class dealerClaimData {
    id: number;
    workshopId: number;
    claimType: number;
    invoicePdfPath: string;
    vehicleImagePaths: string;
    remark: string;
    approvedby: string;
    approvedRemarks: string;
    approvedDate: Date;
    submissionDate: Date;
    status: number;
    dealerCode: string;
    dealerName: string;
    clientId: number;
    transactionId: string;
}

export enum ClaimType {
    Damage = 1,
    Technician = 2,
    Towing = 3
}

export enum ClaimStatus {
    UnderProcess = 0,
    Paid = 1,
    Rejected = 2
}
